/* eslint-disable react/prop-types */
import styles from './css/FilterSection.module.scss';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Catalogs } from 'assets/icons/catalogs.svg';
import { ReactComponent as TopPicks } from 'assets/icons/topPicks.svg';
import { ReactComponent as MyMedia } from 'assets/icons/mymedia.svg';
import { ReactComponent as Folders } from 'assets/icons/folders.svg';

const icons = [
  { Component: Catalogs, name: 'Catalogs', toLink: 'catalogs' },
  { Component: TopPicks, name: 'Top Picks', toLink: 'catalogs/Images' },
  { Component: MyMedia, name: 'My Media', toLink: 'my-files/all-catalogs' },
  { Component: Folders, name: 'Folders', toLink: 'my-files' }
];

function FilterSection () {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <div className={styles.filter}>
        <h1>{t('Redefining speed and creativity')}</h1>
        <div className={styles.iconWrapper}>
          {icons.map(({ Component, name, toLink }, index) => (
          <button onClick={() => navigate(`/mpublisher/${toLink}`)} key={index} className={styles.iconButton}>
              <Component className={styles.icon} />
              <span>{name}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default FilterSection;
